var _classCallCheck = require("/home/runner/work/notes/notes/.layouts/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/notes/notes/.layouts/node_modules/@babel/runtime/helpers/createClass.js");

require("core-js/modules/esnext.global-this.js");

/**
 * @version 0.2.0
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("d3-color"), require("d3-force"), require("d3-scale"), require("force-graph")) : "function" == typeof define && define.amd ? define(["exports", "d3-color", "d3-force", "d3-scale", "force-graph"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).NOTE_GRAPH = {}, e.d3, e.d3, e.d3, e.ForceGraph);
}(this, function (e, t, i, o, n) {
  "use strict";

  function r(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var s = r(n);

  function h(e, t, i, o) {
    var n,
        r = !1,
        s = 0;

    function h() {
      n && clearTimeout(n);
    }

    function a() {
      for (var a = arguments.length, d = new Array(a), l = 0; l < a; l++) {
        d[l] = arguments[l];
      }

      var c = this,
          u = Date.now() - s;

      function g() {
        s = Date.now(), i.apply(c, d);
      }

      function f() {
        n = void 0;
      }

      r || (o && !n && g(), h(), void 0 === o && u > e ? g() : !0 !== t && (n = setTimeout(o ? f : g, void 0 === o ? e - u : e)));
    }

    return "boolean" != typeof t && (o = i, i = t, t = void 0), a.cancel = function () {
      h(), r = !0;
    }, a;
  }

  var a = function a(e, t, i) {
    return void 0 === i ? h(e, t, !1) : h(e, i, !1 !== t);
  };

  var d = function d(e) {
    for (var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      t[_key - 1] = arguments[_key];
    }

    if (!t.length) return e;
    var i = t.shift();
    return void 0 === i ? e : (l(e) && l(i) && Object.keys(i).forEach(function (t) {
      l(i[t]) ? (e[t] || (e[t] = {}), d(e[t], i[t])) : e[t] = i[t];
    }), d.apply(void 0, [e].concat(t)));
  },
      l = function l(e) {
    return function (e) {
      return null !== e && "object" == typeof e;
    }(e) && !Array.isArray(e);
  };

  function c(e, t, i) {
    return getComputedStyle(e).getPropertyValue(t) || i;
  }

  function u() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.container || document.body,
        i = c(t, "--notegraph-highlighted-foreground-color", "#f9c74f");
    return {
      background: c(t, "--notegraph-background", "#f7f7f7"),
      fontSize: parseInt(c(t, "--notegraph-font-size", 12)),
      highlightedForeground: i,
      node: {
        note: {
          regular: c(t, "--notegraph-note-color-regular", "#5f76e7")
        },
        unknown: c(t, "--notegraph-unkown-node-color", "#f94144")
      },
      link: {
        regular: c(t, "--notegraph-link-color-regular", "#ccc"),
        highlighted: c(t, "--notegraph-link-color-highlighted", i)
      },
      hoverNodeLink: {
        highlightedDirection: {
          inbound: "#3078cd",
          outbound: i
        }
      }
    };
  }

  var g = function g(e) {
    return {
      circle: function circle(t, i, o, n) {
        return e.beginPath(), e.arc(t, i, o, 0, 2 * Math.PI, !1), e.fillStyle = n, e.fill(), e.closePath(), this;
      },
      text: function text(t, i, o, n, r) {
        return e.font = "".concat(n, "px Sans-Serif"), e.textAlign = "center", e.textBaseline = "top", e.fillStyle = r, e.fillText(t, i, o), this;
      }
    };
  };

  e.NoteGraphModel = /*#__PURE__*/function () {
    function _class(e) {
      _classCallCheck(this, _class);

      this.subscribers = [], this.notes = e, this.updateCache();
    }

    _createClass(_class, [{
      key: "updateCache",
      value: function updateCache() {
        var _this = this;

        var e = [],
            t = [],
            i = {},
            o = new Map();
        this.notes.forEach(function (n) {
          e.push({
            id: n.id,
            data: {
              note: n
            }
          });
          var r = {
            title: n.title,
            linkIds: [],
            neighbors: []
          };
          n.linkTo && n.linkTo.forEach(function (e) {
            var i = {
              id: _this.formLinkId(n.id, e),
              source: n.id,
              target: e
            };
            t.push(i), o.set(i.id, i), r.linkIds.push(i.id), r.neighbors.push(e);
          }), n.referencedBy && n.referencedBy.forEach(function (e) {
            r.linkIds.push(_this.formLinkId(e, n.id)), r.neighbors.push(e);
          }), i[n.id] = r;
        });
        var n = this.cache || {};
        n.nodeInfos = i, n.links = t, n.linkMap = o, this.cache = n;
      }
    }, {
      key: "getNodeInfoById",
      value: function getNodeInfoById(e) {
        return this.cache.nodeInfos[e];
      }
    }, {
      key: "getLinkById",
      value: function getLinkById(e) {
        return this.cache.linkMap.get(e);
      }
    }, {
      key: "formLinkId",
      value: function formLinkId(e, t) {
        return "".concat(e, "-").concat(t);
      }
    }, {
      key: "toGraphViewData",
      value: function toGraphViewData() {
        return {
          graphData: {
            nodes: this.notes,
            links: this.cache.links
          },
          nodeInfos: this.cache.nodeInfos
        };
      }
    }, {
      key: "publishChange",
      value: function publishChange() {
        var _this2 = this;

        this.subscribers.forEach(function (e) {
          e(_this2);
        });
      }
    }, {
      key: "subscribe",
      value: function subscribe(e) {
        var _this3 = this;

        return this.subscribers.push(e), function () {
          var t = _this3.subscribers.indexOf(e);

          t > -1 && _this3.subscribers.splice(t, 1);
        };
      }
    }]);

    return _class;
  }(), e.NoteGraphView = /*#__PURE__*/function () {
    function _class2(e) {
      _classCallCheck(this, _class2);

      this.hasEngineStopped = !1, this.engineStopSizingFn = null, this.sizeScaler = o.scaleLinear().domain([0, 20]).range([1, 4]).clamp(!0), this.labelAlphaScaler = o.scaleLinear().domain([1.2, 2]).range([0, 1]).clamp(!0), this.interactionCallbacks = {}, this.hasInitialZoomToFit = !1, this.actions = {
        selectNode: function selectNode(e, t, i) {
          i || e.selectedNodes.clear(), null != t && e.selectedNodes.add(t);
        },
        highlightNode: function highlightNode(e, t) {
          e.hoverNode = t;
        }
      }, this.shouldDebugColor = !1, this.options = e, this.container = e.container, this.model = {
        graphData: {
          nodes: [],
          links: []
        },
        nodeInfos: {},
        selectedNodes: new Set(),
        focusNodes: new Set(),
        focusLinks: new Set(),
        hoverNode: null
      }, this.initStyle(), e.graphModel && (this.linkWithGraphModel(e.graphModel), e.lazyInitView || this.initView());
    }

    _createClass(_class2, [{
      key: "initStyle",
      value: function initStyle() {
        this.style || (this.style = u({
          container: this.container
        })), d(this.style, this.options.style);
      }
    }, {
      key: "updateStyle",
      value: function updateStyle(e) {
        this.options.style = d(this.options.style || {}, e), this.initStyle(), this.refreshByStyle();
      }
    }, {
      key: "refreshByStyle",
      value: function refreshByStyle() {
        var _this4 = this;

        if (!this.forceGraph) return;

        var e = t.rgb(this.style.background),
            i = function i(_i, o) {
          var n = o.nodeInfos[_i],
              r = _this4.style.node.note,
              s = _this4.style.node.note[n.type || "regular"] || _this4.style.node.unknown;

          switch (_this4.shouldDebugColor && console.log("node fill", s), _this4.getNodeState(_i, o)) {
            case "regular":
              return {
                fill: s,
                border: s
              };

            case "lessened":
              var _o = r.lessened;

              if (!_o) {
                _o = function (e, i) {
                  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .5;
                  var n = e.r * o + i.r * (1 - o),
                      r = e.g * o + i.g * (1 - o),
                      s = e.b * o + i.b * (1 - o);
                  return t.rgb(n, r, s);
                }(t.rgb(s), e, .2);
              }

              return {
                fill: _o,
                border: _o
              };

            case "highlighted":
              return {
                fill: s,
                border: _this4.style.highlightedForeground
              };

            default:
              throw new Error("Unknown type for node ".concat(_i));
          }
        };

        this.forceGraph.backgroundColor(this.style.background).nodeCanvasObject(function (e, o, n) {
          if (!e.id) return;

          var r = _this4.model.nodeInfos[e.id],
              s = _this4.sizeScaler(r.neighbors ? r.neighbors.length : 1),
              _i2 = i(e.id, _this4.model),
              h = _i2.fill,
              a = _i2.border,
              d = _this4.style.fontSize / n;

          var l = t.rgb(h);

          var c = _this4.getNodeState(e.id, _this4.model),
              u = _this4.labelAlphaScaler(n);

          l.opacity = "highlighted" === c ? 1 : "lessened" === c ? Math.min(.2, u) : u;
          var f = r.title;
          g(o).circle(e.x, e.y, s + .5, a).circle(e.x, e.y, s, h).text(f, e.x, e.y + s + 1, d, l);
        }).linkColor(function (e) {
          return _this4.getLinkColor(e, _this4.model);
        });
      }
    }, {
      key: "linkWithGraphModel",
      value: function linkWithGraphModel(e) {
        var _this5 = this;

        this.currentDataModelEntry && this.currentDataModelEntry.unsub(), this.updateViewData(e.toGraphViewData());
        var t = e.subscribe(function () {
          _this5.updateViewData(e.toGraphViewData());
        });
        this.currentDataModelEntry = {
          graphModel: e,
          unsub: t
        };
      }
    }, {
      key: "getColorOnContainer",
      value: function getColorOnContainer(e, t) {
        return getComputedStyle(this.container).getPropertyValue(e) || t;
      }
    }, {
      key: "updateViewData",
      value: function updateViewData(e) {
        Object.assign(this.model, e), e.focusedNode && (this.model.hoverNode = e.focusedNode);
      }
    }, {
      key: "updateCanvasSize",
      value: function updateCanvasSize(e) {
        this.forceGraph && ("width" in e && this.forceGraph.width(e.width), "height" in e && this.forceGraph.height(e.height));
      }
    }, {
      key: "initView",
      value: function initView() {
        var _this6 = this;

        var e = this.options,
            t = this.model,
            o = this.actions,
            n = s.default || window.ForceGraph,
            r = this.forceGraph || n(),
            h = e.width || window.innerWidth - this.container.offsetLeft - 20,
            a = e.height || window.innerHeight - this.container.offsetTop - 20;
        r(this.container).height(a).width(h).graphData(t.graphData).linkHoverPrecision(8).enableNodeDrag(!!e.enableNodeDrag).cooldownTime(200).d3Force("x", i.forceX()).d3Force("y", i.forceY()).d3Force("collide", i.forceCollide(r.nodeRelSize())).linkWidth(1).linkDirectionalParticles(1).linkDirectionalParticleWidth(function (e) {
          return "highlighted" === _this6.getLinkState(e, t) ? 2 : 0;
        }).onEngineStop(function () {
          _this6.hasEngineStopped = !0, _this6.engineStopSizingFn ? _this6.engineStopSizingFn() : _this6.hasInitialZoomToFit || (_this6.hasInitialZoomToFit = !0, r.zoomToFit(1e3, 20));
        }).onNodeHover(function (e) {
          o.highlightNode(_this6.model, e ? e.id : null), _this6.updateViewModeInteractiveState();
        }).onNodeClick(function (e, t) {
          o.selectNode(_this6.model, e.id, t.getModifierState("Shift")), _this6.updateViewModeInteractiveState(), _this6.fireInteraction("nodeClick", {
            node: e,
            event: t
          });
        }).onLinkClick(function (e, t) {
          _this6.fireInteraction("linkClick", {
            link: e,
            event: t
          });
        }).onBackgroundClick(function (e) {
          o.selectNode(_this6.model, null, e.getModifierState("Shift")), _this6.updateViewModeInteractiveState(), _this6.fireInteraction("backgroundClick", {
            event: e
          });
        }).onBackgroundRightClick(function (e) {
          r.zoomToFit(1e3, 20), _this6.fireInteraction("backgroundRightClick", {
            event: e
          });
        }), !1 !== e.enableSmartZooming && this.initGraphSmartZooming(r), this.forceGraph = r, this.refreshByStyle();
      }
    }, {
      key: "initGraphSmartZooming",
      value: function initGraphSmartZooming(e) {
        var _this7 = this;

        var t = !1;
        var i = a(200, function (e) {
          if (t) return;

          var _this7$forceGraph$get = _this7.forceGraph.getGraphBbox(),
              i = _this7$forceGraph$get.x,
              o = _this7$forceGraph$get.y,
              n = e.k,
              r = e.x,
              s = e.y,
              h = n * i[0],
              a = n * i[1],
              d = n * o[0],
              l = n * o[1],
              c = _this7.forceGraph.width(),
              u = _this7.forceGraph.height(),
              g = _this7.forceGraph.centerAt();

          var f, p;
          a + r < 0 ? (t = !1, f = i[1]) : h + r > c && (f = i[0]), d + s > u ? p = o[0] : l + s < 0 && (p = o[1]), "number" != typeof f && "number" != typeof p || _this7.forceGraph.centerAt(void 0 !== f ? f : g.x, void 0 !== p ? p : g.y, 2e3);
        });
        e.onZoom(function (e) {
          _this7.hasInitialZoomToFit && i(e);
        }).onZoomEnd(function () {
          setTimeout(function () {
            t = !1;
          }, 20);
        });
      }
    }, {
      key: "getLinkNodeId",
      value: function getLinkNodeId(e) {
        var t = typeof e;
        return "string" === t || "number" === t ? e : e.id;
      }
    }, {
      key: "getNodeState",
      value: function getNodeState(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.model;
        return t.selectedNodes.has(e) || t.hoverNode === e ? "highlighted" : 0 === t.focusNodes.size || t.focusNodes.has(e) ? "regular" : "lessened";
      }
    }, {
      key: "getLinkState",
      value: function getLinkState(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.model;
        return 0 === t.focusNodes.size ? "regular" : t.focusLinks.has(e.id) ? "highlighted" : "lessened";
      }
    }, {
      key: "getLinkColor",
      value: function getLinkColor(e, i) {
        var o, n;
        var r = this.style,
            s = r.link;

        switch (this.getLinkState(e, i)) {
          case "regular":
            return s.regular;

          case "highlighted":
            var _h;

            var _a = r.hoverNodeLink;
            return i.hoverNode === this.getLinkNodeId(e.source) ? _h = null === (o = _a.highlightedDirection) || void 0 === o ? void 0 : o.outbound : i.hoverNode === this.getLinkNodeId(e.target) && (_h = null === (n = _a.highlightedDirection) || void 0 === n ? void 0 : n.inbound), _h || s.highlighted || r.highlightedForeground;

          case "lessened":
            var _d = s.lessened;

            if (!_d) {
              var _e = t.hsl(r.node.note.lessened);

              _e.opacity = .2, _d = _e;
            }

            return _d;

          default:
            throw new Error("Unknown type for link ".concat(e));
        }
      }
    }, {
      key: "updateViewModeInteractiveState",
      value: function updateViewModeInteractiveState() {
        var e, t;
        var i = this.model,
            o = new Set(),
            n = new Set();

        if (i.hoverNode) {
          o.add(i.hoverNode);
          var _r = i.nodeInfos[i.hoverNode];
          null === (e = _r.neighbors) || void 0 === e || e.forEach(function (e) {
            return o.add(e);
          }), null === (t = _r.linkIds) || void 0 === t || t.forEach(function (e) {
            return n.add(e);
          });
        }

        i.selectedNodes && i.selectedNodes.forEach(function (e) {
          var t, r;
          o.add(e);
          var s = i.nodeInfos[e];
          null === (t = s.neighbors) || void 0 === t || t.forEach(function (e) {
            return o.add(e);
          }), null === (r = s.linkIds) || void 0 === r || r.forEach(function (e) {
            return n.add(e);
          });
        }), i.focusNodes = o, i.focusLinks = n;
      }
    }, {
      key: "setSelectedNodes",
      value: function setSelectedNodes(e) {
        var _this8 = this;

        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var i = t.isAppend,
            o = t.shouldZoomToFit;

        if (i || this.model.selectedNodes.clear(), e.forEach(function (e) {
          return _this8.actions.selectNode(_this8.model, e, !0);
        }), this.updateViewModeInteractiveState(), o) {
          var _e2 = function _e2() {
            _this8.forceGraph.zoomToFit(1e3, 20, function (e) {
              return _this8.model.focusNodes.has(e.id);
            });
          };

          this.hasEngineStopped ? _e2() : this.engineStopSizingFn = function () {
            _e2(), _this8.engineStopSizingFn = null;
          };
        }
      }
    }, {
      key: "onInteraction",
      value: function onInteraction(e, t) {
        this.interactionCallbacks[e] || (this.interactionCallbacks[e] = []);
        var i = this.interactionCallbacks[e];
        return i.push(t), function () {
          var e = i.indexOf(t);
          e > -1 && i.splice(e, 1);
        };
      }
    }, {
      key: "fireInteraction",
      value: function fireInteraction(e, t) {
        var i = this.interactionCallbacks[e];
        i && i.forEach(function (e) {
          return e(t);
        });
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.forceGraph && this.forceGraph.pauseAnimation();
      }
    }]);

    return _class2;
  }(), e.getColorOnContainer = c, e.getDefaultColorOf = u, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});